import axios from "axios";
import Swal from "sweetalert2";
import { EXPRESS_BASE_URL } from "./apiConfig";

// Register sayfasindaki ile ayni sozlesme/kvkk metinlerine linkler -
// yeni sekmede acilsinlar diye duz <a target="_blank"> kullaniliyor
// (Swal HTML'i React agacinin disinda, Router Link burada calismaz).
const ACCEPTANCE_HTML = `
  <div style="text-align:left;">
    <div class="form-check mb-3">
      <input class="form-check-input" type="checkbox" id="corpAcceptSozlesme" />
      <label class="form-check-label" for="corpAcceptSozlesme">
        <a href="/kullanicisozlesmesi" target="_blank" style="text-decoration:underline;">Kullanım Koşulları ve Üyelik Sözleşmesini</a>
        &nbsp;Kabul ediyorum.
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="checkbox" id="corpAcceptKvkk" />
      <label class="form-check-label" for="corpAcceptKvkk">
        <a href="/aydinlatmametni" target="_blank" style="text-decoration:underline;">KVKK Aydınlatma Metni ve Açık Rıza Metnini</a>
        &nbsp;Kabul ediyorum.
      </label>
    </div>
  </div>
`;

// Kurumsal (okula bagli) ogretmen ve ogrenciler icin: CorporateUsersAcceptance
// tablosunda bu userid ile kayit yoksa, kabul edene kadar hicbir sayfada
// islem yapilmasina izin vermiyoruz. DashboardLayout mount olurken bir kez
// cagrilir; Swal, Outlet icerigi degisse (sayfa gezinse) bile ekranda kalir
// cunku DashboardLayout navigasyon boyunca unmount olmuyor.
export const ensureCorporateUserAcceptance = async (userInfo, userDetail) => {
    if (!userInfo) return;

    const roleName = userInfo.roleName;
    const isTeacher = roleName === "Teacher";
    const isCorporateStudent = roleName === "Student" && userInfo.isInvidual === false;
    if (!isTeacher && !isCorporateStudent) return;

    try {
        const checkRes = await axios.get(
            `${EXPRESS_BASE_URL}/getcorporateusersacceptancebyuserid/${userInfo.id}`
        );
        if (Array.isArray(checkRes.data) && checkRes.data.length > 0) return;
    } catch (err) {
        console.error("Kurumsal onay kaydı kontrol edilirken hata oluştu:", err);
        return;
    }

    let saved = false;
    while (!saved) {
        await Swal.fire({
            title: "Kullanım Koşulları ve KVKK Onayı",
            html: ACCEPTANCE_HTML,
            showCancelButton: false,
            showCloseButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonText: "Kabul Ediyorum ve Devam Et",
            preConfirm: () => {
                const sozlesmeChecked = document.getElementById("corpAcceptSozlesme")?.checked;
                const kvkkChecked = document.getElementById("corpAcceptKvkk")?.checked;
                if (!sozlesmeChecked || !kvkkChecked) {
                    Swal.showValidationMessage("Devam edebilmek için her iki kutuyu da işaretlemelisiniz.");
                    return false;
                }
                return true;
            },
        });

        try {
            await axios.post(`${EXPRESS_BASE_URL}/postcorporateusersacceptance`, {
                userid: userInfo.id,
                name: userInfo.fullName,
                email: userInfo.username,
                kvkk: 1,
                sozlesme: 1,
                type: isTeacher ? 1 : 0,
                schoolid: userDetail?.schoolId || 0,
                classid: userDetail?.classId || 0,
            });
            saved = true;
        } catch (err) {
            await Swal.fire({
                title: "Hata",
                text: "Kaydınız oluşturulamadı, lütfen tekrar deneyiniz.",
                icon: "error",
                confirmButtonText: "Tamam",
            });
        }
    }
};
